
<template>
  <div class="notifyBtn">
    <el-button
      type="primary"
      style="width:60px;text-align:left;padding-left:3px;"
      v-if="items.TotalNum=='0'"
    >
      <i class="el-icon-bell"></i>
      <span class="notifyNum">{{items.TotalNum}}</span>
    </el-button>
    <el-dropdown trigger="click" v-if="items.TotalNum!='0'" @command="handleCommand">
      <el-button
        :type="buttontype"
        style="width:60px;text-align:left;padding-left:3px;"
        @click="GetUnreadDetail()"
      >
        <i class="el-icon-bell"></i>
        <span class="notifyNum">{{items.TotalNum}}</span>
      </el-button>
      <el-dropdown-menu slot="dropdown" class="notifyNumMenu">
        <el-dropdown-item v-for="(item,index) in detail" :key="index" :command="item.MainUrl">
          <img width="40" height="40" :src="item.PictureUrl" align="left">
          &nbsp;&nbsp;{{item.LeadName}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import "signalr";
import Global from "@/components/Global";
import { SignalrConnectionHandler } from "@/handler/SignalrConnectionHandler.js";

export default {
  name: "Notify",
  components: {},
  data() {
    return {
      items: [],
      detail: [],
      timer: "",
      buttontype: "danger",
      conn: null
    };
  },
  // 元件銷毀時停掉連線與計時器。SignalrConnectionHandler 會無限退避重連，
  // 沒停的話會留下永遠重連的殭屍連線。
  beforeDestroy() {
    if (this.conn && typeof this.conn.stop === "function") {
      this.conn.stop();
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    this.initdata();
    this.timer = setInterval(this.blink, 500);
   
  },
  props: {},
  methods: {
    initdata: function() {
      // 存在元件上，beforeDestroy 才停得掉（否則會留下永遠重連的殭屍連線）
      this.conn = SignalrConnectionHandler.Create({
        url: this.$conf.MessageAPI + "/signalr",
        hub: "pushHub",
        // 每次重連成功後都要重新註冊，否則推播不會再進來
        onConnected: function(proxy) {
          proxy.invoke(
            "Notify",
            Global.widget_staff,
            Global.widget_accesstoken
          );
        }
      });
      var proxy = this.conn.proxy;
      Global.proxy = proxy;
      this.conn.start();

      proxy.on("notifyClient", data => {
        this.items = data;
      });

      proxy.on("reflashNotify", data => {
        this.items = data;      
      });

      proxy.on("getUnreadDetail", data => {
        this.detail = data;
      });
    },
    GetUnreadDetail() {
      this.detail = [];

      Global.proxy.invoke(
        "GetUnreadDetail",
        Global.widget_staff,
        Global.widget_accesstoken
      );
    },
    blink() {
      if (this.buttontype == "danger") {
        this.buttontype = "primary";
        return;
      }
      if (this.buttontype == "primary") {
        this.buttontype = "danger";
        return;
      }
    },
    handleCommand(command) {     
      window.open(command);
    }
  }
};
</script>

<style>
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Notify.vue